export default __webpack_public_path__ + "static/media/groupBy.f4eb233c.svg";